function checkInRange(name, a, min, max, nullableOri) {
    let nullable = false;

    if (typeof nullableOri !== 'undefined') {
        nullable = nullableOri;
    }

    if (typeof a === 'number') {
        if (a >= min && a <= max) {
            return;
        }
        throw new Error(
            `${name} is not in [${min}, ${max}] range.`
        );
    } else if (a === null) {
        if (!nullable) {
            throw new Error(
                `${name} is null but it shouldn't be nullable.`
            );
        }
    } else {
        throw new Error(
            `${name} is not a number.`
        );
    }
}

function applyEncodingConfig(parameters, maxBitrate) {
    const encodingList = parameters.encodings;

    for (let i = 0; i < encodingList.length; i++) {
        const encoding = encodingList[i];

        if (maxBitrate === null) {
            if ('maxBitrate' in encoding) {
                delete encoding.maxBitrate;
            }
        } else {
            encoding.maxBitrate = maxBitrate;
        }
    }

    return parameters;
}

class CallRtpSettingsStatic {
    constructor() {
        // Is in bits per second.
        this.videoMaxBitrate = null;
        this.audioMaxBitrate = null;
    }

    copy() {
        const settingsCopy = new CallRtpSettingsStatic();

        settingsCopy.videoMaxBitrate = this.videoMaxBitrate;
        settingsCopy.audioMaxBitrate = this.audioMaxBitrate;

        return settingsCopy;
    }

    check() {
        // Min: 1 kbps, Max: 100 Mbps, nullable
        checkInRange('videoMaxBitrate', this.videoMaxBitrate, 1000, 100000000, true);
        // Min: 1 kbps, Max: 1 Mbps, nullable
        checkInRange('audioMaxBitrate', this.audioMaxBitrate, 1000, 1024000, true);
    }

    video(parametersOri) {
        this.check();

        const parameters = applyEncodingConfig(
            parametersOri,
            this.videoMaxBitrate
        );

        return parameters;
    }

    audio(parametersOri) {
        this.check();

        const parameters = applyEncodingConfig(
            parametersOri,
            this.audioMaxBitrate
        );

        return parameters;
    }

    both(connection) {
        this.check();

        const senderList = connection.getSenders();
        let appliedParameters = null;

        for (let i = 0; i < senderList.length; i++) {
            const sender = senderList[i];
            const track = sender.track;

            if (track !== null) {
                const trackKind = track.kind;
                let parameters = sender.getParameters();

                if (trackKind === 'video') {
                    parameters = this.video(parameters);
                } else if (trackKind === 'audio') {
                    parameters = this.audio(parameters);
                } else {
                    parameters = null;
                }

                if (parameters !== null) {
                    if (appliedParameters === null) {
                        appliedParameters = [];
                    }

                    appliedParameters.push(
                        sender.setParameters(parameters)
                    );
                }
            }
        }

        if (appliedParameters !== null) {
            return Promise.all(appliedParameters);
        }
        return null;
    }
}

export default CallRtpSettingsStatic;
